import React from 'react'
import connect from 'react-redux/es/connect/connect';
import ApiTab from '../../components/ApiTab/ApiTab'
import BulkOverview from '../../components/Overview/BulkOverview';
import Documentation from '../../components/Documentation/Documentation';
import BulkFaq from '../../components/Faq/BulkFaq';
import ImgBanner from '../../../assets/img/bg_header.png'
import { useEffect, useState } from "react";
import { saveApiTabSelection } from '../../stores/ApiTabSelectionParam/ApiTabSelectionParamActions';
import { getApiConfig } from '../../../api/developer';
import BILLoader from '../../components/BILLoader/BILLoader';

//// STYLE
import '../../../assets/style/home.scss'
import './index.css'

const BulkApiDocumentation = (props) => {

    const year = new Date().getFullYear()
    const { apiTabSelection } = props;
    const [apiConfig, setApiConfig] = useState({});
    const [isLoading, setLoading] = useState(true);


    useEffect(() => {
        getApiConfig("bulk-pis")
            .then((res) => setApiConfig(res.data))
            .finally(() => setTimeout(() => { setLoading(false) }, 700))
    }, []);

    return (
        <div className="marketplace-container">
            <div className="header-home-page">
                <img src={ImgBanner} className="banner-home" alt="banner" />
                <div className="btn-get-started">
                    <h1>
                        Try our<br />
                        <span>Bulk Payment API</span>
                    </h1>
                </div>
            </div>
            <ApiTab />
            {!isLoading ?
                <DisplayAssociatedTab apiTabSelection={apiTabSelection} apiConfig={apiConfig} />
                :
                <div className="intl-spinner-container">
                    <BILLoader />
                </div>
            }
            <section className="section-footer text-center">
                <p>Copyright © {year} - Banque Internationale à Luxembourg SA All rights reserved.</p>
            </section>
        </div>
    )
}

const DisplayAssociatedTab = (props) => {

    switch (props.apiTabSelection) {
        case "Overview":
            return <BulkOverview overviewConfig={props.apiConfig.overview} />
        case "Documentation":
            return <Documentation swaggerConfig={props.apiConfig.swagger} />
        case "Faq":
            return <BulkFaq faqConfig={props.apiConfig.faq} />
        default:
            return null
    }
}

//// JS REDUX
const mapStateToProps = (state) => ({
    apiTabSelection: state.apiTabSelectionParam.apiTabSelection,
});

const mapDispatchToProps = {
    saveApiTabSelection,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkApiDocumentation);